import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Input, InputLabel } from "@mui/material";
import React, { useRef } from "react";

const CompanyKyndLiveModal = (props) => {

	const user_name = useRef(null);
	const email = useRef(null);
	
	const handleClose = () => {
		props.onClose()
	};
	
	const handleSubmit = () => {
		const kyndLiveRequest = {
			user_name: user_name.current.value,
			email: email.current.value,
			companyId: props.company.id
		};
		props.onSubmit(kyndLiveRequest);
	};
	
	const handleSubmitForm = (e) => {
		e.preventDefault();
		handleSubmit();
	};
	
	const handleCancel = () => {
		props.onClose();
	};
	
	const formControlStyle = {
		width: "80%",
		maxWidth: "35em",
		margin: "1em 10%"
	};
	
	return (
		<Dialog
			open={props.company}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title">
				Set KYND Live for {props.company? props.company.name : ""}
			</DialogTitle>
			<DialogContent>
				<form onSubmit={handleSubmitForm} autoComplete="off">
					<FormControl sx={formControlStyle}>
						<InputLabel htmlFor="user_name">User name</InputLabel>
						<Input inputRef={user_name} id="user_name"/>
					</FormControl>
					<FormControl sx={formControlStyle}>
						<InputLabel htmlFor="email">Email</InputLabel>
						<Input inputRef={email} id="email"/>
					</FormControl>
				</form>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCancel}>Cancel</Button>
				<Button onClick={handleSubmit} autoFocus>Submit</Button>
			</DialogActions>
		</Dialog>
	);

}

export default CompanyKyndLiveModal;